import heiselLogoDark from "@heiselanalytics/sailplot/assets/heisel-analytics-logo-on-dark.png";
import heiselLogoLight from "@heiselanalytics/sailplot/assets/heisel-analytics-logo-on-light.png";
import sailplotIcon from "@heiselanalytics/sailplot/icons/sailplot-icon.svg";
import sailplotLogoDark from "@heiselanalytics/sailplot/icons/sailplot-logo-on-dark.svg";
import sailplotLogoLight from "@heiselanalytics/sailplot/icons/sailplot-logo-on-light.svg";

export const coreAssets = {
  heiselLogoDark,
  heiselLogoLight,
  sailplotIcon,
  sailplotLogoDark,
  sailplotLogoLight,
} as const;
